import {Sentence} from "./Sentences";


class SentenceStore {
    private static cacheByPath = new Map<string, Sentence[]>();
    private static loadingByPath = new Map<string, Promise<Sentence[]>>();

    static async getSentences(path: string): Promise<Sentence[]> {
        const normalized = path.startsWith("/") ? path : `/${path}`;

        const cached = this.cacheByPath.get(normalized);
        if (cached) return cached;

        const existingPromise = this.loadingByPath.get(normalized);
        if (existingPromise) return existingPromise;

        const promise = fetch(normalized)
            .then(res => {
                if (!res.ok) throw new Error(`Failed to load ${normalized} (${res.status})`);
                return res.text();
            })
            .then(text => {
                const sentences: Sentence[] = text
                    .split(/\r?\n/)
                    .filter(l => l.length > 0 && !l.startsWith("#"))
                    .map(l => l.trim().replace("—", "; ").replace("  ", " "))
                    .map((line, i) => ({
                        id: i + 1,
                        plain: line,
                        html: line,
                    }));

                this.cacheByPath.set(normalized, sentences);
                this.loadingByPath.delete(normalized);
                return sentences;
            })
            .catch(err => {
                this.loadingByPath.delete(normalized);
                throw err;
            });

        this.loadingByPath.set(normalized, promise);
        return promise;
    }

    static clear(path?: string) {
        if (!path) {
            this.cacheByPath.clear();
            this.loadingByPath.clear();
            return;
        }
        const normalized = path.startsWith("/") ? path : `/${path}`;
        this.cacheByPath.delete(normalized);
        this.loadingByPath.delete(normalized);
    }
}

export default SentenceStore;
